import React, { useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './footer';
import Navbar from './Navbar';
import { AppContext } from '../util/AppContext';
import Splash from '../pages/splash';
import SystemAnouncementsCard from './SystemAnnouncementsCard';
import Breadcrumb from './BreadCrumbs';
import { BreadcrumbProvider, useBreadcrumbs } from '../util/BreadcrumbContext';
import ApplicationSelectionHomePage from "../pages/applicationSelectionHomePage";
import { getConfigValue } from '../util/getConfigValue';

function LayoutInner() {
	const [appState] = useContext(AppContext);
	const { breadcrumbs } = useBreadcrumbs();
	const location = useLocation();

    const hasAGIAccess = !appState.configLoaded ? false : appState?.hasAgiAccess ?? false;
    const isLandingPageEnabled = !appState.configLoaded ? false : getConfigValue(appState?.config?.LandingPage?.Enabled, appState)?.Value === 'true';
	const hasShowApplicationLandingPage = sessionStorage.getItem("hasShownApplicationSelection")?.toLowerCase() === "true";
	const showApplicationLandingPart = location.pathname === "/"
	? (isLandingPageEnabled && hasAGIAccess && !hasShowApplicationLandingPage) 
	: false;

	return (
		<>
			{appState.appReady ? (
				<>
					{showApplicationLandingPart && (						
						// new landing page
						<ApplicationSelectionHomePage />) 
					}
					{!showApplicationLandingPart && (
						<>
							<Navbar />
							<Breadcrumb items={breadcrumbs} />
							<SystemAnouncementsCard />
							<Outlet />
							<Footer />
						</>) 
					}
				</>
			) : (
				<Splash />
			)}
		</>
	);
}

export default function Layout() {
	return (
		<BreadcrumbProvider>
			<LayoutInner />
		</BreadcrumbProvider>		
	);
}
